var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Context',{staticClass:"variables-context",attrs:{"overflow-scroll":"","max-height-if-outside-viewport":""}},[_c('div',{staticStyle:{"padding":"5px"}},[_vm._v(_vm._s(_vm.$t('common.comingSoon')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }